import { ALPHA_WEB_URL, ALPHA_API_URL } from './alpha.mjs';
import { DEV_WEB_URL, DEV_API_URL } from './dev.mjs';
import { LOCAL_WEB_URL, LOCAL_API_URL } from './local.mjs';
import { REAL_WEB_URL, REAL_API_URL } from './real.mjs';
import { STAGE_WEB_URL, STAGE_API_URL } from './stage.mjs';
import { TEST_WEB_URL, TEST_API_URL } from './test.mjs';

const SERVICE_MAP = {
  alpha: ALPHA_WEB_URL,
  dev: DEV_WEB_URL,
  test: TEST_WEB_URL,
  local: LOCAL_WEB_URL,
  stage: STAGE_WEB_URL,
  real: REAL_WEB_URL
};
const API_SERVICE_MAP = {
  alpha: ALPHA_API_URL,
  dev: DEV_API_URL,
  test: TEST_API_URL,
  local: LOCAL_API_URL,
  stage: STAGE_API_URL,
  real: REAL_API_URL
};

export { API_SERVICE_MAP, SERVICE_MAP };
